/**
 * Returns 1 if new page is greater than the current product search, -1 if it
 * is lower and 0 if it is the same page.
 * @param {ProductSearch} productSearch - current product search
 * @param {ProductSearch} newProductSearch - new product search
 * @returns {number} comparison result
 */
const comparePageNumber = (productSearch, newProductSearch) => {
  const currentPage = productSearch?.pageNumber;
  const newPage = newProductSearch?.pageNumber;
  if (currentPage > newPage) return -1;
  if (currentPage < newPage) return 1;
  return 0;
};

/**
 * Returns true if the given product search has the same category than a new one
 * @param {ProductSearch} productSearch - current product search
 * @param {ProductSearch} newProductSearch - new product search
 * @returns {boolean}
 */
const haveSameCategory = (productSearch, newProductSearch) =>
  productSearch?.category?.id === newProductSearch?.category?.id;

export { comparePageNumber, haveSameCategory };
